import service from '../utils/request';
// 添加获取入库订单列表接口
export function getStockInOrderList(params) {
  return service.get('/uic-system/warein/page', {
    params: {
      wareInStatus: params.wareInStatus || '',
      current: params.current || 1,
      size: params.size || 20
    }
  });
}

// 添加获取入库订单详情接口
export function getStockInOrderDetail(id) {
  return service.get('/uic-system/warein/detail', {
    params: {
      id: id
    }
  });
}

// 添加确认收货接口
export function confirmCollect(wareInId) {
  return service.post('/uic-system/api_hf/warein/collect/confirm', {
    id: wareInId
  });
}